{
  "home": {
    "title": "Home",
    "welcome": "Welkom bij MVL Creative OS",
    "subtitle": "Klik op een app in de dock onderaan om te beginnen"
  },
  "portfolio": {
    "title": "Portfolio",
    "subtitle": "Mijn werk in actie",
    "filter": "Filter",
    "categories": {
      "all": "Alles",
      "video": "Video",
      "apps": "Apps",
      "ux": "UX"
    },
    "backToGrid": "Terug naar portfolio",
    "aboutProject": "Over dit project"
  },
  "expertise": {
    "title": "Expertise",
    "subtitle": "Mijn vakgebieden",
    "domains": {
      "design": "Design & UX",
      "ai": "AI & Creatie",
      "tech": "Technologie & Development",
      "strategy": "Strategie & Concept"
    }
  },
  "process": {
    "title": "Proces",
    "subtitle": "Mijn werkwijze in 5 fases"
  },
  "about": {
    "title": "Over Mij",
    "subtitle": "Mijn verhaal",
    "intro": "Hoi, ik ben Mick",
    "tagline": "Ik vertaal complexe vragen naar elegante oplossingen",
    "translation": {
      "title": "De Vertaalslag",
      "question": "hoe maak ik het complexe simpel?"
    },
    "pillars": {
      "title": "Drie Pijlers, Één Aanpak",
      "aiVideo": {
        "title": "AI Video Generation",
        "description": "Creative storytelling met AI"
      },
      "vibeCoding": {
        "title": "Vibe Coding",
        "description": "AI-powered rapid prototyping"
      },
      "uxThinking": {
        "title": "UX Thinking",
        "description": "Gebruikerservaring als fundament"
      }
    },
    "howTheyWork": {
      "title": "Hoe Ze Samenwerken",
      "discover": "Ontdekken",
      "prototype": "Prototypen",
      "tell": "Vertellen"
    }
  },
  "contact": {
    "title": "Contact",
    "subtitle": "Laten we in gesprek gaan",
    "form": {
      "name": "Naam",
      "email": "E-mail",
      "message": "Bericht",
      "send": "Verstuur"
    }
  },
  "settings": {
    "title": "Instellingen",
    "subtitle": "Personaliseer je ervaring",
    "theme": {
      "title": "Thema",
      "dark": "Dark",
      "light": "Light",
      "neon": "Neon",
      "highContrast": "High Contrast"
    },
    "background": {
      "title": "Achtergrond",
      "subtitle": "Kies een gradient voor light theme"
    },
    "language": {
      "title": "Taal / Language",
      "dutch": "Nederlands",
      "english": "English"
    },
    "about": {
      "title": "Over MVL Creative OS",
      "version": "Versie",
      "description": "Een macOS-geïnspireerd portfolio operating system gebouwd met React, TypeScript en Tailwind CSS."
    }
  }
}